import React, { useState } from "react";
import PriceCalculator from "../PriceCalculator";

const ProductCard = ({
  image,
  title,
  description,
  attributes,
  productId,
  imagePosition = "center",
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="w-full mb-10 bg-main-light shadow-lg">
      <div className="flex flex-col md:flex-row md:items-stretch">
        {/* Image */}
        <div className="md:w-2/5 h-[280px] md:h-auto md:min-h-[500px] relative overflow-hidden shrink-0">
          <img
            src={image}
            alt={title}
            className="absolute inset-0 w-full h-full object-cover"
            style={{ objectPosition: imagePosition }}
          />
        </div>

        {/* Content */}
        <div className="md:w-3/5 flex flex-col justify-between gap-6 p-6 md:p-8">
          <div className="space-y-4">
            <h4 className="text-main-dark font-heading font-bold text-xl md:text-2xl">
              {title}
            </h4>
            <p className="text-main-dark font-copy leading-relaxed">
              {description}
            </p>
            {attributes && attributes.length > 0 && (
              <div className="flex flex-wrap gap-2 pt-2">
                {attributes.map((attr, index) => (
                  <span
                    key={index}
                    className="text-sm font-copy font-bold text-main-dark bg-grey/20 px-3 py-1"
                  >
                    {attr}
                  </span>
                ))}
              </div>
            )}
          </div>

          {/* Toggle Button */}
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="cta cta-dark self-start flex items-center gap-2"
          >
            Se størrelser og priser
            <span className="text-xl">{isExpanded ? "−" : "+"}</span>
          </button>
        </div>
      </div>

      {/* Price Calculator */}
      {isExpanded && <PriceCalculator productId={productId} />}
    </div>
  );
};

export default ProductCard;
